var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", [
    _vm.currentTimestamp
      ? _c("tr", [
          _vm._m(0),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "fixed-width-time" }, [
              _vm._v(_vm._s(_vm.currentFormatted))
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("\n      " + _vm._s(_vm.timezone) + "\n    ")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.startTimestamp
      ? _c("tr", [
          _vm._m(1),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "fixed-width-time" }, [
              _vm._v(_vm._s(_vm.startFormatted))
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("\n      " + _vm._s(_vm.timezone) + "\n    ")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.endTimestamp
      ? _c("tr", [
          _vm._m(2),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "fixed-width-time" }, [
              _vm._v(_vm._s(_vm.endFormatted))
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("\n      " + _vm._s(_vm.timezone) + "\n    ")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Current Time:  ")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Session start:  ")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Session end:  ")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }